import { Link, Outlet } from 'react-router-dom';
import Footer from './Footer';

export default function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
          <Link to="/" className="font-semibold tracking-tight text-emerald-800">AEA · Espacio de Datos</Link>
          <nav className="flex items-center gap-3 text-sm">
            <Link to="/contact" className="hidden text-slate-600 hover:text-emerald-700 sm:block">Contacto</Link>
            <Link to="/login" className="rounded-lg border border-emerald-700 px-4 py-2 text-emerald-800 hover:bg-emerald-50">Iniciar sesión</Link>
            <Link to="/register" className="rounded-lg bg-emerald-700 px-4 py-2 text-white hover:bg-emerald-800">Solicitar alta</Link>
          </nav>
        </div>
      </header>
      <main className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}
